
export const findDistinctLendersByQuotes = (quotes, maxLenders) => findDistinctLenders(quotes, maxLenders);

const findDistinctLenders = (quotes, maxLenders) => {
  if (quotes && quotes.length > 0) {
    const distinctList = quotes.reduce((accum, cur) => {
      if (!cur || !cur.loanProvider || cur.loanProvider.length === 0 || !cur.lenderCompany) {
        return accum;
      }
      if (!accum.some(item => item.lenderCompany.id === cur.lenderCompany.id)) {
        accum.push(cur);
      }

      return accum;
    }, []).slice(0, maxLenders);

    return distinctList.reduce((accum, cur) => {
      if (!cur && cur.loanProvider && cur.loanProvider.length) {
        return accum;
      }
      accum.push({
        lenderName: cur.loanProvider[0].name,
        logo: cur.loanProvider[0].logoImage,
        id: cur.loanProvider[0].id,
        loanSeniority: cur.loanSeniority.value,
        closingDate: cur.closingDate,
        currentBalance: cur.currentPrincipalBalance,
        maturityDate: cur.maturityDate,
        prepaymentPenalty: cur.prepaymentPenalty,
        isLockout: cur.isLockout
      });

      return accum;
    }, []);
  }
};

